import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';

interface NotificationsSectionProps {
  soundNotificationsEnabled: boolean;
  onToggle: (enabled: boolean) => void;
  isUpdating?: boolean;
}

/**
 * NotificationsSection Component
 * Allows users to toggle sound notifications on/off
 */
export const NotificationsSection: React.FC<NotificationsSectionProps> = ({
  soundNotificationsEnabled,
  onToggle,
  isUpdating = false
}) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-4">
          <div className="p-2 bg-blue-50 rounded-lg">
            <BellIcon className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Notifications sonores
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Activer les alertes sonores pour les nouvelles tâches et paiements
            </p>
          </div>
        </div>

        <div className="flex items-center">
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={soundNotificationsEnabled}
              onChange={(e) => onToggle(e.target.checked)}
              disabled={isUpdating}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
          </label>
        </div>
      </div>

      {isUpdating && (
        <div className="mt-3 flex items-center gap-2 text-sm text-gray-500">
          <div className="animate-spin h-4 w-4 border-2 border-blue-600 border-t-transparent rounded-full"></div>
          <span>Enregistrement...</span>
        </div>
      )}
    </div>
  );
};
